import * as Yup from 'yup';

export type FormikLikeErrors<T> = Partial<{ [key in keyof T]: string }>;

export default function getErrorsLikeFormik<T>(schema: any, values: T): FormikLikeErrors<T> {
  try {
    schema.validateSync(values, { abortEarly: false });
    return {};
  } catch (err) {
    if (err instanceof Yup.ValidationError) {
      return err.inner.reduce<any>((acc, curr) => {
        if (curr.path && !acc[curr.path]) {
          acc[curr.path] = curr.message;
        }
        return acc;
      }, {});
    }
    return {};
  }
}
